// extracted by mini-css-extract-plugin
export default {"aboutDescription":"CampaignAboutCard_aboutDescription__PfBd5","aboutSection":"CampaignAboutCard_aboutSection__QB+lA"};